import { Route, useLocation, Navigate } from "react-router-dom";
import AuthPage from "./components/account/AuthPage";
import DashBoardPage from "./components/dashboard/Board";
import Mapdev from "./mapWithSidebar";
import PreviewPage from "./components/dashboard/selectArea/PreviewPage";
import ProjectPage from "./components/adminDashboard/project";
import Verification from "./components/account/Verification";
import UserLayout from "./UserLayout";
import SetUpPassword from "./components/SetUpPassword";
import CompleteProfilePage from "./components/account/CompleteProfile";
import Proposal from "./components/proposal";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("jwtToken");
  const location = useLocation();
  if (!token) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
      />
    );
  }

  return children;
};

const UserRoutes = () => [
  <Route path="/" element={<UserLayout />}>
    <Route index element={<Mapdev />} />

    <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <DashBoardPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/preview"
      element={
        // <ProtectedRoute>
        <PreviewPage />
        // </ProtectedRoute>
      }
    />
    <Route path="/login" element={<AuthPage />} />
    <Route path="/verification" element={<Verification />} />
    <Route
      path="/dashboard/project/:id"
      element={
        // <ProtectedRoute>
          <ProjectPage />
        // </ProtectedRoute>
      }
    />

    {/* Set Up Password Routes */}
    <Route path="/set-up-process/:token" element={<SetUpPassword />} />
    {/* Set Up Password Routes */}

    <Route path="/complete-profile/:token" element={<CompleteProfilePage />} />
    <Route path="/proposal" element={<Proposal />} />

    {/* <Route path="/forgot-password" element={<ForgotPasswordPage />} /> */}
    {/* <Route path="/reset-password" element={<ResetPasswordPage />} /> */}
  </Route>,
];

export default UserRoutes;
